import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import PublicLayout from "@/components/layout/PublicLayout";
import { useAuth } from "@/contexts/AuthContext";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const redirectTo = location.state?.redirectTo || "/command-center";

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    const result = await login(email, password);
    setBusy(false);
    if (result.ok) {
      if (result.user.role === "admin" || result.user.role === "super_admin") {
        navigate("/admin");
      } else if (result.user.role === "evaluator") {
        navigate("/evaluator/dashboard");
      } else if (result.user.role === "scout") {
        navigate("/evaluator");
      } else if (result.user.role === "player") {
        navigate("/my-profile");
      } else if (result.user.role === "recruiter") {
        navigate("/recruiter");
      } else {
        navigate(redirectTo);
      }
    } else {
      setError(result.error || "Login failed");
    }
  };

  return (
    <PublicLayout>
      <div className="min-h-[calc(100vh-200px)] bg-[#F8F9FA] flex items-center justify-center py-16 px-6">
        <div className="w-full max-w-md">
          <div className="bg-white border border-slate-200 p-10 rounded-sm">
            <div className="label-overline text-[#E63946]">Sign In</div>
            <h1 className="font-display text-4xl uppercase tracking-tighter mt-2">Welcome Back</h1>
            <p className="text-sm text-slate-600 mt-2">Access your parent dashboard or CBR admin console.</p>

            {error && (
              <div data-testid="login-error" className="mt-6 border-l-4 border-[#E63946] bg-red-50 p-3 text-sm text-[#E63946]">
                {error}
              </div>
            )}

            <form onSubmit={onSubmit} className="mt-6 space-y-4">
              <div>
                <label className="label-overline">Email</label>
                <input
                  data-testid="login-email-input"
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="mt-2 w-full px-4 py-3 border border-slate-300 rounded-sm focus:border-[#0A192F]"
                />
              </div>
              <div>
                <label className="label-overline">Password</label>
                <input
                  data-testid="login-password-input"
                  type="password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="mt-2 w-full px-4 py-3 border border-slate-300 rounded-sm focus:border-[#0A192F]"
                />
              </div>
              <button
                data-testid="login-submit-button"
                type="submit"
                disabled={busy}
                className="w-full bg-[#0A192F] hover:bg-[#1a2a4a] text-white py-3 text-sm font-semibold uppercase tracking-wider rounded-sm disabled:opacity-60"
              >
                {busy ? "Signing in…" : "Sign In"}
              </button>
              <div className="text-right">
                <Link data-testid="forgot-password-link" to="/forgot-password" className="text-xs text-slate-500 hover:text-[#E63946] uppercase tracking-wider">
                  Forgot password?
                </Link>
              </div>
            </form>

            <div className="mt-6 text-center text-sm text-slate-600">
              Don&apos;t have an account?{" "}
              <Link to="/signup" state={location.state} className="text-[#E63946] font-semibold uppercase tracking-wider text-xs">
                Create one
              </Link>
            </div>
          </div>
        </div>
      </div>
    </PublicLayout>
  );
}
